// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TAddRealEstateRequest,
  TAddRealEstateModel,
  IMappers,
  TAddRealEstateResponse,
  TAddRealEstateResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createAddRealEstateModel(parameters: TAddRealEstateRequest): TAddRealEstateModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'cian-dobro',
    pathApi: '/v1/add-real-estate/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IAddRealEstateOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TAddRealEstateRequest;
}

export async function fetchAddRealEstate<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IAddRealEstateOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TAddRealEstateResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createAddRealEstateModel(parameters),
    config,
  )) as FetchResponse<TAddRealEstateResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TAddRealEstateResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TAddRealEstateResponse>;
}
